import { Component, DestroyRef, OnInit, inject, signal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { InputBlockComponent } from "../../input-block/input-block/input-block.component";
import { SmartRadioBlock } from "../../types/block";

@Component({
  selector: "ail-smart-radio-block",
  template: "",
})
export class SmartRadioBlockComponent extends InputBlockComponent<SmartRadioBlock>
  implements OnInit {
  private readonly _destroyRef = inject(DestroyRef);
  selectionCountUsed = 0;
  readonly showAllAnswers = signal(false);

  ngOnInit() {
    super.ngOnInit();
    this.inputFormControl()
      ?.valueChanges.pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(() => this.validateSelection());
  }

  validateSelection() {
    this.selectionCountUsed += 1;
    if (
      !this.data().config.selection_count ||
      this.data().config.selection_count === this.selectionCountUsed
    ) {
      this.showAllAnswers.set(true);
      this.inputFormControl().disable({
        onlySelf: true,
      });
    }
  }
}
